// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"78529b0f","599":"2729e8e0"}[chunkId] + ".chunk.js";
};